import { shouldForwardProp } from '@mui/system';

var createComponentSlot = function createComponentSlot(_ref) {
  var name = _ref.name,
      slot = _ref.slot,
      skipForwardProps = _ref.skipForwardProps;
  var camelCaseSlot = slot.charAt(0).toLowerCase() + slot.slice(1);
  return {
    name: name,
    slot: slot,
    className: "".concat(name, "-").concat(camelCaseSlot),
    styledOptions: {
      name: name,
      slot: slot,
      overridesResolver: function overridesResolver(props, styles) {
        if (props !== null && props !== void 0 && props.variant) {
          return [styles[camelCaseSlot], styles[props.variant]];
        }

        return styles[camelCaseSlot];
      },
      shouldForwardProp: function shouldForwardProp$1(prop) {
        return shouldForwardProp(prop) && !(skipForwardProps !== null && skipForwardProps !== void 0 ? skipForwardProps : []).includes(prop);
      }
    }
  };
};

export { createComponentSlot };
